// Calendar-date display for API values that are a DAY, not an instant (Gitea #139 / plan 105).
// Accepts 'YYYY-MM-DD', an ISO timestamp whose leading date part is the day (how a node-pg DATE column serialises
// from a server at or west of UTC: prod/staging run TZ=America/New_York, CI runs UTC), or a Date built locally.
// Never `new Date(string)` + local getters: 'YYYY-MM-DD' parses as UTC midnight (a day early in every browser west
// of UTC) and an ISO instant reads a day early in every browser west of the server.
// Same idiom as the local fmtDate helpers in CommandPalette.js and AdminHome.js (which omit the year).
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})(?:[T ].*)?$/;

// [year, month (1-12), day] for a real calendar date, else null.
export const dateOnlyParts = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : [value.getFullYear(), value.getMonth() + 1, value.getDate()];
  }
  const m = DATE_ONLY.exec(String(value).trim());
  if (!m) return null;
  const [y, mo, d] = [m[1], m[2], m[3]].map(Number);
  const t = new Date(Date.UTC(y, mo - 1, d));
  if (t.getUTCFullYear() !== y || t.getUTCMonth() !== mo - 1 || t.getUTCDate() !== d) return null;
  return [y, mo, d];
};

// "Jan 16, 2027" in every browser zone. Intl options may be overridden; the date is always rendered in UTC.
export const formatDateOnly = (value, options = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  const parts = dateOnlyParts(value);
  if (!parts) return '';
  const [y, mo, d] = parts;
  return new Date(Date.UTC(y, mo - 1, d)).toLocaleDateString('en-US', { ...options, timeZone: 'UTC' });
};
